module.exports = __webpack_public_path__ + "img/bg.1e2ef470.png";